// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityRequest {
    static getAttributeTypeMap() {
        return MedicalEligibilityRequest.attributeTypeMap;
    }
}
MedicalEligibilityRequest.discriminator = undefined;
MedicalEligibilityRequest.additionalProperties = false;
MedicalEligibilityRequest.attributeTypeMap = [
    {
        "name": "mock",
        "baseName": "mock",
        "type": "boolean"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "MedicalEligibilityPatientRequest"
    },
    {
        "name": "payor",
        "baseName": "payor",
        "type": "MedicalEligibilityPayorRequest"
    },
    {
        "name": "practice",
        "baseName": "practice",
        "type": "MedicalEligibilityPractice"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "MedicalEligibilityPrescriberRequest"
    },
    {
        "name": "treatmentDate",
        "baseName": "treatmentDate",
        "type": "Date"
    },
    {
        "name": "clientId1",
        "baseName": "clientId1",
        "type": "string"
    },
    {
        "name": "clientId2",
        "baseName": "clientId2",
        "type": "string"
    },
    {
        "name": "clientId3",
        "baseName": "clientId3",
        "type": "string"
    },
    {
        "name": "clientId4",
        "baseName": "clientId4",
        "type": "string"
    },
    {
        "name": "clientId5",
        "baseName": "clientId5",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityRequest.js.map